import React from 'react';
import { Carousel } from 'react-bootstrap';

function toWebp(src) {
  const webp = src.replace(/\.(jpg|jpeg|png)$/i, '.webp');
  return webp.replace(/ /g, '%20');
}

function MainSection(prop) {
  let headerClass = 'highlight-text-dark header-large-text';
  let textClass = "highlight-text-dark para-normal-text";
  let mainPhoto = "../main_l.jpg";
  let secondPhoto = "../second_l.jpg";
  let thirdPhoto = "../third_l.jpg";

  if (prop.pageWidth < 900 && prop.pageWidth > 500) {
    mainPhoto = "../main_s.jpg";
    secondPhoto = "../second_s.jpg";
    thirdPhoto = "../third_s.jpg";
    headerClass = 'highlight-text-dark header-medium-text';
  } else if (prop.pageWidth <= 500 && prop.pageWidth > 400) {
    mainPhoto = "../main_s.jpg";
    secondPhoto = "../second_s.jpg";
    thirdPhoto = "../third_s.jpg";
    headerClass = 'highlight-text-dark header-small-text';
  } else if (prop.pageWidth <= 400) {
    mainPhoto = "../main_s.jpg";
    secondPhoto = "../second_s.jpg";
    thirdPhoto = "../third_s.jpg";
    textClass = "highlight-text-dark para-small-text";
    headerClass = 'highlight-text-dark header-xsmall-text';
  }

  const slideAlts = (prop.strings.slides && prop.strings.slides.imgAlts) || [
    "Tralo paslaugos Kaune – automobilio pervežimas",
    "Patyrusi traliuko komanda – pagalba kelyje",
    "Saugus automobilio transportavimas traliuku Lietuvoje"
  ];

  const h1Text = prop.strings.seo && prop.strings.seo.h1
    ? prop.strings.seo.h1
    : "Tralo paslaugos Kaune ir visoje Lietuvoje – pigi ir greita pagalba kelyje 24/7";

  const slide = (src, alt, isFirst, header, text) => (
    <Carousel.Item>
      <picture>
        <source srcSet={toWebp(src)} type="image/webp" />
        <img
          className="d-block w-100"
          src={src}
          alt={alt}
          width="1280"
          height="533"
          {...(isFirst ? { fetchpriority: "high" } : { loading: "lazy" })}
          decoding="async"
        />
      </picture>
      <Carousel.Caption>
        <h2 className={headerClass}>{header}</h2>
        <p className={textClass}>{text}</p>
      </Carousel.Caption>
    </Carousel.Item>
  );

  return (
    <div className={!prop.onTop ? 'padding-top' : undefined}>
      <h1 className="visually-hidden">{h1Text}</h1>
      <Carousel>
        {slide(mainPhoto, slideAlts[0], true, prop.strings.slides.slideOneHeader, prop.strings.slides.slideOneText)}
        {slide(secondPhoto, slideAlts[1], false, prop.strings.slides.slideTwoHeader, prop.strings.slides.slideTwoText)}
        {slide(thirdPhoto, slideAlts[2], false, prop.strings.slides.slideThreeHeader, prop.strings.slides.slideThreeText)}
      </Carousel>
    </div>
  )
}

export default MainSection;
